
import {payload} from './state.js'

const SET_LIST = (state,items) =>{

    state.items = items

}

const SET_BYID = (state,payload) =>{

    state.payload = payload

}

const CHECK_FORM = (state,status) =>{

    state.payload = payload
    state.status = status

}

export default {
    SET_LIST,
    SET_BYID,
    CHECK_FORM, 
}